import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-account',
  templateUrl: './icon-account.component.html',
  styleUrl: './icon-account.component.scss',
  standalone: false,
})
export class IconAccountComponent {
  @Input() tooltip?: string;
}
